<template>
  <div class="wrapper inline-grid grid-cols-9 col-gap width-full">
    <header class="page-title col-span-6 col-start-2">
      <h1 class="header-one">
        Pointer events
      </h1>
      <p class="page-title__sub">
        Utility classes for pointer events.
      </p>
    </header>
    <section class="section col-span-6 col-start-2">
      <div class="table">
        <table>
          <thead>
            <tr>
              <th>Class</th>
              <th>Properties</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <code class="code__class">.pointer-auto</code>
              </td>
              <td>
                <code class="code__prop">pointer-events: auto;</code>
              </td>
            </tr>
            <tr>
              <td>
                <code class="code__class">.pointer-none</code>
              </td>
              <td>
                <code class="code__prop">pointer-events: none;</code>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <section class="section col-span-6 col-start-2">
      <header class="section__title">
        <h2 class="header-two">
          Auto
        </h2>
      </header>
      <p>
        <code class="margin-left-0">.pointer-auto</code> is used when you want the element to
        use the browsers default behaviour.
      </p>
      <code-block>
        <template #code>
          <pre class="language-html" rel="html">
          <code>&lt;div class="field field--select..."&gt;
  &lt;label for="usage_pointer_auto" class="label"&gt;
    ...
  &lt;/label&gt;
  &lt;div class="select"&gt;
    &lt;select id="usage_pointer_auto"&gt;
        ...
    &lt;/select&gt;
    &lt;span class="pointer-auto select__icon..."&gt;
        ...
    &lt;/span&gt;
  &lt;/div&gt;
&lt;/div&gt;</code>
          </pre>
        </template>
      </code-block>
      <preview>
        <template #preview>
          <div class="bg-wrapper grid grid-cols-4 col-gap l-col-gap m-col-gap sm-col-gap
          align-items-stretch width-full bg-selective-yellow grid-rows-3
          padding-top-30 padding-bottom-30 container l-container m-container s-container"
          >
            <p class="body-small font-gibson-med col-span-2 col-start-2 m-col-span-4 m-col-start-1">
              Click the icon to test the pointer event
            </p>
            <div class="field field--select col-span-2 col-start-2 m-col-span-4 m-col-start-1
              flex flex-col margin-bottom-20"
            >
              <label for="usage_pointer_auto"
                     class="margin-bottom-5"
              >
                <code class="code">.pointer-auto</code>
              </label>
              <div class="select">
                <select id="usage_pointer_auto">
                  <option>Charles Francis Xavier</option>
                  <option>Scott Summers</option>
                  <option>Robert Louis Drake</option>
                  <option>Warren Kenneth Worthington III</option>
                  <option>Henry Philip McCoy</option>
                  <option>Jean Elaine Grey</option>
                </select>
                <down class="pointer-auto select__icon" />
              </div>
            </div>
          </div>
        </template>
      </preview>
    </section>
    <section class="section col-span-6 col-start-2">
      <header class="section__title">
        <h2 class="header-two">
          None
        </h2>
      </header>
      <p>
        <code class="margin-left-0">.pointer-none</code> should be used to prevent an element
        from responding to it's default pointer event. The pointer event
        will be inherited from the element that's underneath it.
      </p>
      <code-block>
        <template #code>
          <pre class="language-html" rel="html">
          <code>&lt;div class="field field--select..."&gt;
  &lt;label for="usage_pointer_none" class="label"&gt;
    ...
  &lt;/label&gt;
  &lt;div class="select"&gt;
    &lt;select id="usage_pointer_none"&gt;
        ...
    &lt;/select&gt;
    &lt;span class="pointer-none select__icon..."&gt;
        ...
    &lt;/span&gt;
  &lt;/div&gt;
&lt;/div&gt;</code>
          </pre>
        </template>
      </code-block>
      <preview>
        <template #preview>
          <div class="bg-wrapper grid grid-cols-4 col-gap l-col-gap m-col-gap sm-col-gap
          align-items-stretch width-full bg-selective-yellow grid-rows-3
          padding-top-30 padding-bottom-30 container l-container m-container s-container"
          >
            <p class="body-small font-gibson-med col-span-2 col-start-2 m-col-span-4 m-col-start-1">
              Click the icon to test the pointer event
            </p>
            <div class="field field--select col-span-2 col-start-2 m-col-span-4 m-col-start-1
              flex flex-col"
            >
              <label for="usage_pointer_none"
                     class="margin-bottom-5"
              >
                <code class="code">.pointer-none</code>
              </label>
              <div class="select">
                <select id="usage_pointer_none">
                  <option>Charles Francis Xavier</option>
                  <option>Scott Summers</option>
                  <option>Robert Louis Drake</option>
                  <option>Warren Kenneth Worthington III</option>
                  <option>Henry Philip McCoy</option>
                  <option>Jean Elaine Grey</option>
                </select>
                <down class="pointer-none select__icon" />
              </div>
            </div>
          </div>
        </template>
      </preview>
    </section>
  </div>
</template>

<script>
import Preview from '@/components/Preview';
import CodeBlock from '@/components/Code-Block';
import Down from '@/components/svgs/Down';

export default {
  name: 'PointerEvents',
  components: {
    Preview,
    CodeBlock,
    Down,
  },
};
</script>
